export function downloadText(fileName: string, text: string, mediaType: string): void {
  // Without an explicit charset, some consumers guess the wrong encoding when reading the
  // downloaded file back (e.g. multi-byte characters like the "₂" in an H₂ label can come back
  // corrupted) even though the Blob's own bytes are always UTF-8 for a JS string source.
  const blob = new Blob([text], { type: `${mediaType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}

// #758 -- a binary download (PNG/JPEG/PDF export).
export function downloadBlob(fileName: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  // Let the click start the download before the URL goes away.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
